import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Constants } from "../../../../constants/constants";
import Helpers from "../../../../constants/helpers";
import { UpsellPanelSteps } from "../../../../constants/upsellPanelEnumsAndConstants";
import { useUpsellWidgetRedirect } from "../../hooks/useRedirectContext";
import useSMSTokenTimer from "../../hooks/useSMSTokenTimer";
import { useUpsellWidgetContainer } from "../../hooks/useUpsellWidgetContainerContext";
import { useUpsellWidgetModel } from "../../hooks/useUpsellWidgetModelContext";
import { useMFALoginMutation, useRequestMFATokenMutation } from "../../services/hooks/useMFAMutations";
import ValidationErrorsSummary from "../UpSellWidgetContainer/ValidationErrorsSummary";
import { RememberMeCheckbox } from "./FormControls";
import { RequestSMSCode } from "./FormControls/RequestSMSCode";
import { VerificationCodeInput } from "./FormControls/VerificationCodeInput";

export const Step17MFALogin = () => {
  const model = useUpsellWidgetModel();
  const { currentStep, baseProps, boldClass, handleErrorResponse, onSubmitError, setIsUpsellContainerLoading } = useUpsellWidgetContainer();
  const { resetTimer, remainingTime, getRemainingTimeText } = useSMSTokenTimer();
  const { handleRedirect } = useUpsellWidgetRedirect();
  const [formErrors, setFormErrors] = useState({});
  const [tokenResponse, setTokenResponse] = useState({});

  if (currentStep !== UpsellPanelSteps.Step17MFALogin) {
    return null;
  }
  const { mutate: mfaLogin, data: loginResponse } = useMFALoginMutation();
  const { mutate: requestMFAToken } = useRequestMFATokenMutation();

  const {
    register,
    resetField,
    handleSubmit,
    formState: { errors, isSubmitted },
    watch
  } = useForm();
  const verificationCode = watch('verificationCode');
  const handlRequestMFATokenSuccess = (response) => {
    resetTimer();
    setTokenResponse({
      success: true,
      css: response.status === Constants.RequestStatus.SUCCESS ? Constants.CssClass.ALERT_SUCCESS : Constants.CssClass.ALERT_DANGER,
      text: response.msg
    })
    if (response.errors) {
      handleErrorResponse(response.errors, setFormErrors);
    }
    setIsUpsellContainerLoading(false);
  }
  const handleLoginSuccess = (response) => {
    if (response.status === Constants.RequestStatus.SUCCESS) {
      window.authenticateAllDomains(response);
      if (model.investmentQuizGoalTypeID > 0) {
        //model.createSOA();
        return;
      } else if (model.investmentQuizSoaID > 0) {
        //model.updateSOASubscriber();
      } else {
        handleRedirect(response);
      }
    } else if (response.errors) {
      handleErrorResponse(response.errors, setFormErrors);
      setIsUpsellContainerLoading(false);
    }
  }

  const onSubmit = (formData) => {
    setIsUpsellContainerLoading(true);
    mfaLogin({
      ...formData,
      email: baseProps.user.email,
      mfaAuthenticator: baseProps.mfaModel.mfaAuthenticator,
      mfaText: baseProps.mfaModel.mfaText
    }, {
      onSuccess: handleLoginSuccess,
      onError: (error) => onSubmitError(error)
    });
  };

  const onRequestMFATokenClick = () => {
    setIsUpsellContainerLoading(true);
    resetField('verificationCode');
    requestMFAToken(baseProps.user.email,
      {
        onSuccess: handlRequestMFATokenSuccess,
        onError: (error) => onSubmitError(error)
      })
  }

  useEffect(() => {
    if (!!!verificationCode && !Helpers.isEmpty(formErrors)) {
      setFormErrors({});
    }
  }, [verificationCode, formErrors])

  return (
    <div className="step17">
      {isSubmitted && errors && (<div className="upsell-container-content">
        <ValidationErrorsSummary validationErrors={{ ...errors, ...formErrors }} />
      </div>)}
      <form className="join-form-inline form-is-custom form-disable-pristine-error" onSubmit={handleSubmit(onSubmit)}
        noValidate>
        <div className="row">
          <div className="col-md-12">
            <div className="upsell-panel-paragraph font-circular-std-bold font-25 mb-3">
              {Constants.TWO_FACTOR_AUTHENTICATION}
            </div>
            {/* Alert for MFA Token Response */}
            {tokenResponse.success && (
              <div className={`alert alert-dismissible fade in ${tokenResponse.css}`}>
                <p className="font-15">
                  <span>{tokenResponse.text}</span>
                </p>
              </div>
            )}

            {/* Invalid MFA Token Alert */}
            {isSubmitted && loginResponse?.invalidMfaToken && (
              <div className="alert alert-danger text-left" role="alert">
                <p>{Constants.AUTH_CODE_NOT_VALID}</p>
              </div>
            )}

            {/* MFA Authenticator Text */}
            {baseProps.mfaModel.mfaAuthenticator && (
              <div className="font-16 mb-3" dangerouslySetInnerHTML={{ __html: Constants.MFA_AUTH_APP_CODE_SENT_COPY_TEXT }}>
              </div>
            )}
            {baseProps.mfaModel.mfaText && !baseProps.mfaModel.mfaAuthenticator && (
              <div className="font-16 mb-3">
                {Constants.MFA_MOBILE_CODE_SENT_COPY_TEXT}
              </div>
            )}

            {/* Verification Code Input */}
            <div className="d-flex align-items-center mb-3 flex-column flex-md-row">
              <VerificationCodeInput register={register} errors={errors} name='verificationCode' />
              <button className={`btn btn-primary btn-brand-style-with-pad-sm ml-2 font-19 ml-4 ${boldClass}`}
                type="submit">
                {Constants.BUTTON_TEXT_VERIFY_AND_LOGIN}
              </button>
            </div>
          </div>

          {/* Remember Me Checkbox */}
          <div className="col-md-12 text-left">
            <RememberMeCheckbox register={register} showRememberDeviceText={true} />
          </div>

          {/* Additional MFA Text */}
          <div className="col-md-12 col-12 font-17 my-3 t-l">
            {baseProps.mfaModel.mfaAuthenticator && !baseProps.mfaModel.mfaText && (
              <span>{Constants.MFA_AUTH_APP_REQUEST_SMS_CODE_COPY_TEXT}</span>
            )}
            {!baseProps.mfaModel.mfaAuthenticator && baseProps.mfaModel.mfaText && (
              <span>{Constants.MFA_RESEND_SMS_CODE_COPY_TEXT}</span>
            )}
          </div>

          {/* Request MFA Code Button */}
          <RequestSMSCode
            btnText={Constants.MFA_REQUEST_CODE}
            btnCss={'btn btn-secondary btn-fw btn-brand-style-with-pad font-19 border-rad-99-imp cursor-pointer'}
            remainingTime={remainingTime}
            getRemainingTimeText={getRemainingTimeText}
            onRequestTokenClick={onRequestMFATokenClick}
          />
        </div>
      </form>
    </div>
  );
};

